export interface ControlRail {
  /** Settings cluster (upper-right): Layers + Theme. */
  settings: HTMLElement;
  /** Navigation cluster (lower-right): zoom + locate. */
  nav: HTMLElement;
}

/** Build the two control groups (settings + nav) inside the given root. */
export function createControlRail(root: HTMLElement): ControlRail {
  const group = (modifier: string): HTMLElement => {
    const el = document.createElement('div');
    el.className = `control-group control-group--${modifier}`;
    root.appendChild(el);
    return el;
  };
  return { settings: group('settings'), nav: group('nav') };
}
